import qsa from 'dom-helpers/querySelectorAll';
import { subscribeNews } from 'core/api/earlybird';
import { _get } from 'core/utils/object-prop';
import { actions } from 'core/redux/features/shared';
import on from 'dom-helpers/addEventListener';
import closest from 'dom-helpers/closest';
import toggleCls from 'dom-helpers/toggleClass';
import hasClass from 'dom-helpers/hasClass';

export const subscribeEmail = async (stores, email, city) => {
    const { local } = stores.getState();

    try {
        const result = await subscribeNews({
            email,
            city,
            local,
        });

        if (result?.message) {
            stores.dispatch(actions.notifyAlert(result.message));
        }
        return true;
    } catch (e) {
        const res = await e.response.json();
        if (res?.error && res?.message) {
            stores.dispatch(actions.notifyAlert(res.message));
        }
    }

    return false;
};

export const subscribeForm = (doc, stores) => {
    on(doc, 'click', e => {
        if (!e.target || !hasClass(e.target, 'btn-newsletter-submit')) {
            return;
        }

        const newsForm = closest(e.target, '.newsletter-form');
        if (!newsForm) {
            return;
        }

        e.preventDefault();

        toggleCls(e.target, 'disabled');
        const city = _get(qsa(newsForm, '[name="city"]'), 0).value;
        const email = _get(qsa(newsForm, '[name="email"]'), 0).value;
        subscribeEmail(stores, email, city).finally(() => {
            toggleCls(e.target, 'disabled');
        });
    });
};
